// GettingStartedGuide.js
import React, { useState, useEffect } from "react";
import { Modal, Box, Typography } from "@mui/material";
import ReactMarkdown from "react-markdown";

// Modal style for the Getting Started guide
const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: 800,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  outline: "none",
  overflowY: "auto",
  maxHeight: "90vh",
};

const GettingStartedGuide = ({ guideOpen, handleGuideClose }) => {
  const [guideContent, setGuideContent] = useState("");

  // Fetch the markdown file from the public folder when component mounts
  useEffect(() => {
    fetch(`${process.env.PUBLIC_URL}/gettingStartedForEndUser.md`)
      .then((res) => res.text())
      .then((text) => setGuideContent(text))
      .catch((err) => console.error("Error fetching markdown:", err));
  }, []);

  return (
    <Modal
      open={guideOpen}
      onClose={handleGuideClose}
      aria-labelledby="guide-modal-title"
      aria-describedby="guide-modal-description"
    >
      <Box sx={modalStyle}>
        <Typography id="guide-modal-title" variant="h5" gutterBottom>
          Getting Started Guide
        </Typography>
        <ReactMarkdown>{guideContent}</ReactMarkdown>
      </Box>
    </Modal>
  );
};

export default GettingStartedGuide;
